import { render, staticRenderFns } from "./AtomButtonSubmitPrimary.vue?vue&type=template&id=3833201e"
import script from "./AtomButtonSubmitPrimary.vue?vue&type=script&lang=js"
export * from "./AtomButtonSubmitPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports